export default __webpack_public_path__ + "a400c40540b888fcbf8492dd45fa4ecd.svg";